<template>
  <v-container
    fluid
    class="fs-admin-container"
  >
    <v-layout
      class="fs-archive"
      mb-3
    >
      <v-flex mb-3>
        <h1>{{title}}</h1>
      </v-flex>
    </v-layout>
    <v-layout
      wrap
      class="fs-header-filter"
    >
      <v-flex md2>
        <RangeDatePicker
          startDateLabel="Дата операции с"
          endDateLabel="Дата операции до"
          :startDate.sync="filter.start_at"
          :endDate.sync="filter.end_at"
          @changeRange="filterEvents"
          dense
        />
      </v-flex>
      <v-flex md2>
        <Select
          v-model="filter.event"
          :items="balanceEvents"
          :item-text="'name'"
          :item-value="'id'"
          label="Тип операции:"
          class="fs-admin-complex-autocomplete"
          @change="filterEvents"
          flat
          dense
          blank
        />
      </v-flex>
    </v-layout>
    <v-layout
      class="fs-admin-archive-result"
      mb-3
      justify-space-around
    >
      <v-flex>
        <Table
          :headers="headers"
          :items="items"
          :items-per-page.sync="itemsPerPage"
          :server-items-length="totalItems"
          :page.sync="page"
          @update:request="updateRequest"
          disable-sort
          no-data-text="Транзакции отсутствуют"
          class="elevation-1"
        >
          <template
            v-slot:body.append
            v-if="items.length"
          >
            <tr>
              <td
                colspan="4"
                class="text-md-right"
              >Итого списаний: {{getTotal(WITHDRAW)}} р.</td>
            </tr>
            <tr>
              <td
                colspan="4"
                class="text-md-right"
              >Итого пополнений: {{getTotal(REFILL)}} р.</td>
            </tr>
          </template>
        </Table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { BASE, FORMAT } from '@/config'
import { GET_BALANCE_HISTORY } from '@/requests/parent'
import { Table, RangeDatePicker, Select } from '@/components/common'

export default {
  name: 'BalanceHistory',
  components: {
    Table,
    Select,
    RangeDatePicker
  },
  data() {
    return {
      title: 'Движение денежных средств',
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Дата и время операции', value: 'date' },
        { text: 'Сумма операции в рублях', value: 'amount' },
        { text: 'Операция', value: 'event.name' }
      ],
      items: [],
      dataTableLoaded: false,
      page: 1,
      itemsPerPage: BASE.LIMIT,
      offset: 0,
      totalItems: 0,
      filter: {
        start_at: moment()
          .add(-7, 'days')
          .format(FORMAT.datepickerDate),
        end_at: moment().format(FORMAT.datepickerDate),
        event: null
      },
      eventTypes: []
    }
  },
  created() {
    this.loadBalanceHistory()
  },
  computed: {
    ...mapState({
      childId: state => state.child.childId,
      balanceConstants: state => state.common.constants.balance_events,
      balanceEvents: state =>
        state.common.constants.balance_events.map(e => ({
          name: e.name,
          id: e.id
        })),
      REFILL: state =>
        state.common.constants.balance_events.find(e => e.alias === 'REFILL'),
      WITHDRAW: state =>
        state.common.constants.balance_events.find(e => e.alias === 'WITHDRAW')
    })
  },
  methods: {
    getTotal(eventType) {
      return this.items.reduce(
        (acc, i) => (i.event.id === eventType.id ? acc + i.amount : acc),
        0
      )
    },
    updateRequest({ offset, itemsPerPage }) {
      this.offset = offset
      this.itemsPerPage = itemsPerPage
      this.loadBalanceHistory()
    },
    filterEvents() {
      this.page = 1
      this.offset = 0
      this.loadBalanceHistory()
    },
    async loadBalanceHistory() {
      try {
        const {
          data: { results, count }
        } = await GET_BALANCE_HISTORY(this.childId, {
          limit: this.itemsPerPage,
          offset: this.offset,
          date_from: this.filter.start_at
            ? moment(this.filter.start_at).format(FORMAT.datepickerDate)
            : null,
          date_to: this.filter.end_at
            ? moment(this.filter.end_at).format(FORMAT.datepickerDate)
            : null,
          event: this.filter.event
        })

        this.totalItems = count
        this.items = results.map(r => ({
          ...r,
          amount: r.amount / 100,
          event: this.balanceConstants.find(c => c.id === r.event),
          date: moment(r.created_at).format(FORMAT.dateTimeShort)
        }))
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось получить историю движения средств'
        })
      }
    }
  }
}
</script>